<div id="footer" class="footer-wrap">
    <div class="container">
        <div class="row">
            <div class="col text-center"><a href="/">Insta</a></div>
            <div class="col text-center"><a href="/css-fun">FB</a></div>
            <div class="col text-center"><a href="">Nope</a></div>
        </div>
    </div>
</div>
